import _regeneratorRuntime from "C:/Users/hujun/Desktop/front-end/GLP-PC/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "C:/Users/hujun/Desktop/front-end/GLP-PC/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "C:/Users/hujun/Desktop/front-end/GLP-PC/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import { mapMutations } from "vuex";
import { dateFormat, getAge } from "@/utils/utils";
import request from "@/utils/request";
import { getExpectLoseWeight } from "@/api";
export default {
  components: {},
  data: function data() {
    return {
      form: {
        sex: null,
        birthday: new Date("1970-07-15"),
        height: null,
        weight: null
      },
      showForm: true,
      show1: false,
      result: {}
    };
  },
  beforeRouteLeave: function beforeRouteLeave() {
    this.UPDATE_SHOWNAVLOGO_VALUE(false);
  },
  created: function created() {
    this.UPDATE_SHOWNAVLOGO_VALUE(true);
  },
  methods: _objectSpread(_objectSpread({}, mapMutations(["UPDATE_SHOWNAVLOGO_VALUE"])), {}, {
    numberFn: function numberFn(p) {
      this.form[p] = this.form[p].replace(/[^\-\d.]/g, "") //只能输入   数字 小数点 -
      .replace(/\-{2,}/g, "-") // 只能出现一次-
      .replace(/^0+(\d)/, "$1") //如果第一位是 0 就替换成后面的数字
      .replace(/^\./, "0.") //如果第一位是 . 就 替换成  0.
      .match(/^[\d\-]*(\.?\d{0,2})/g)[0] || ""; //开头只能允许数字或者 -
    },
    submit: function submit() {
      var _this$form = this.form,
        sex = _this$form.sex,
        birthday = _this$form.birthday,
        height = _this$form.height,
        weight = _this$form.weight;
      if (sex === null) {
        this.$toast("请选择性别");
      } else if (birthday === null) {
        this.$toast("请选择出生日期");
      } else if (!height) {
        this.$toast("请输入身高");
      } else if (!weight) {
        this.$toast("请输入体重");
      } else {
        this.form["birth"] = dateFormat("YYYY-mm-dd", this.form.birthday);
        if (getAge(this.form["birth"]) < 18) {
          this.$toast("您的年龄小于18岁，我们不支持对18岁以下人群提供服务。");
        } else {
          console.log(this.form);
          this.getResult();
        }
      }
    },
    getResult: function getResult() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var params, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              params = _this.form;
              _context.next = 3;
              return request.get(getExpectLoseWeight, {
                params: params
              });
            case 3:
              res = _context.sent;
              if (!(res.code != 0 || !res.obj)) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return");
            case 6:
              _this.result = res.obj || {};
              _this.showForm = false;
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  })
};